// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/deals-list-item/deals-list-item.component.scss
// module id = 261
// module chunks = 0